import { render, staticRenderFns } from "./button.vue?vue&type=template&id=7f1f02b1&scoped=true&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&lang=css&"
import style1 from "./button.vue?vue&type=style&index=1&id=7f1f02b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1f02b1",
  null
  
)

export default component.exports